import type { ProjectReferenceMatchDocumentRecordSchema } from '@/entities/project/api/generated/model';
import type { Judgement, MatchingCandidate } from '@/features/ai-matching-results/lib/types';

/**
 * 参照マッチ取得APIの `is_user_selected` を判定（Judgement）へ変換する。
 *
 * - true → 該当（matched）
 * - false → 非該当（not-matched）
 * - null / undefined（未操作）→ 未判定（pending）
 */
export const userSelectedToJudgement = (isUserSelected: boolean | null | undefined): Judgement => {
  if (isUserSelected === true) return 'matched';
  if (isUserSelected === false) return 'not-matched';
  return 'pending';
};

/**
 * `ProjectReferenceMatchDocumentRecordSchema[]`（新参照マッチ取得API）を
 * マッチングスキルカードの候補表示用 `MatchingCandidate[]` に変換する。
 *
 * - candidateId は record の `id`（PATCH 対象 documentRecordId と一致させる）
 * - title は `record_name`（ID は表示しない / ITA-2794。document_name にはフォールバックしない）
 * - 該当理由（matchReasons）は record_citation_reason を 1 件の箇条書きとして渡す（空文字は除外）
 * - 補足（supplement）は record_description を渡す（空文字は除外。markdown 表示）
 *
 * 注: fundingSourceId は財源側サイドパネルのハイライト判定専用フィールドで、
 * 事業詳細マッチング tab では使用しないため空文字を設定する。
 */
export const mapDocumentRecordsToCandidates = (
  documents: ProjectReferenceMatchDocumentRecordSchema[],
): MatchingCandidate[] =>
  documents.map((record) => ({
    candidateId: record.id,
    title: record.record_name,
    judgement: userSelectedToJudgement(record.is_user_selected),
    fundingSourceId: '',
    matchReasons: record.record_citation_reason ? [record.record_citation_reason] : undefined,
    supplement: record.record_description || undefined,
  }));
